export const PAGE_TITLE_SET = 'PAGE_TITLE_SET';
export const PAGE_TITLE_CLEAR = 'PAGE_TITLE_CLEAR';
export const LANG_SET = 'LANG_SET';